import { cn } from "../../lib/utils.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ui/status-banner.tsx
const VARIANT_CLASS = {
	success: "border-success-200 bg-surface-success",
	warning: "border-warning-200 bg-surface-warning",
	error: "border-error-200 bg-surface-error",
	info: "border-accent-sky-200 bg-accent-sky-25",
	neutral: "border-border bg-muted"
};
const DOT_CLASS = {
	success: "bg-success-500",
	warning: "bg-warning-500",
	error: "bg-error-500",
	info: "bg-accent-sky-500",
	neutral: "bg-muted-foreground"
};
function StatusBanner({ variant = "neutral", title, children, action, icon, role, className, ...props }) {
	return /* @__PURE__ */ jsxs("div", {
		role: role ?? (variant === "error" ? "alert" : "status"),
		"data-variant": variant,
		className: cn("flex flex-wrap items-start gap-x-4 gap-y-2 rounded-inset border px-4 py-3 text-text-body", VARIANT_CLASS[variant], className),
		...props,
		children: [
			icon ? /* @__PURE__ */ jsx("span", {
				"aria-hidden": true,
				className: "mt-0.5 flex shrink-0",
				children: icon
			}) : /* @__PURE__ */ jsx("span", {
				"aria-hidden": true,
				className: cn("mt-1.5 size-2 shrink-0 rounded-full", DOT_CLASS[variant])
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "body-sm min-w-0 flex-1",
				children: [title ? /* @__PURE__ */ jsxs("span", {
					className: "font-medium",
					children: [title, " "]
				}) : null, children]
			}),
			action ? /* @__PURE__ */ jsx("span", {
				className: "body-sm shrink-0 font-medium [&_a]:underline-offset-2 [&_a:hover]:underline",
				children: action
			}) : null
		]
	});
}
//#endregion
export { StatusBanner };
